// Boot-Process for the javascript.
// The order of each line might have drastic results.
//
// Currently the boot order is as follows:
// - Platform code (The things that make TicketMachine run)
// - Legacy code
// - Modules and Entrypoints
// - Tasks
// - (Loaded asynchronous: Autorun code)

// Actually a no-op. Makes .css appear.
const current_nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute("value")!;
if (!!current_nonce) {
    __webpack_nonce__ = current_nonce;
}

require("./backend/stylesheet");

// Show a spinner for the start.
import boot from "./_boot";
import { registerDelayed } from "./_module_preloader";


let _unleashModules = () => {};

(async (steps: (() => Promise<void>)[]) => {
    try {
        boot.start();
        for (let step of steps) {
            try {
                await step();
            } catch (e) {
                window.reportError(e);
            }
        }

        console.log("[Boot] Bootup complete...");
    } finally {
        boot.finish();
    }
})([
    async () => {
        const {default: jq} = await import(
            /* webpackPrefetch: true */
            /* webpackPreload: true */
            "@vendor/stage0/0_jquery"
        );
        // Make jquery available early.
        (window as any).$ = jq;
        (window as any).jQuery = jq;
        console.debug("[Boot] Early stage requirements loaded.");
    },

    // Expose the module system early.
    async () => {
        _unleashModules = registerDelayed();
        require("./platform/_preload").registerTmImport();
        require("./components/CustomElements/entrypoint");
        console.debug("[Boot] Entrypoint Loader defined");
    },

    // Load the platform code
    async () => {
        require("./_error");
        require("./polyfills");
        await Promise.all([
            import(/* webpackMode: "eager" */ "./platform"),
            import(/* webpackMode: "eager" */ "./utils/translations"),
            import("./_errors/backend")
        ]);
        console.debug("[Boot] Platform code loaded.");
    },

    async () => {
        require("./modules");
        console.debug("[Boot] Early hints loaded.");
    },

    // Execute legacy code.
    async () => {
        await import(
            /* webpackPrefetch: true */
            /* webpackPreload: true */
            "./legacy/index"
        );
        console.debug("[Boot] Legacy code executed.") 
        boot.finish();
    },

    // Load modules as background tasks.
    async () => {
        _unleashModules();
        await Promise.all([
            import(/* webpackMode: "lazy-once" */ "./tasks"),
            import(/* webpackMode: "eager" */ "./backend/update_display"),
        ]); 
        console.debug("[Boot] Modules loaded.");
    },

    // Auto-run stuff
    async () => {
        await import(
            /* webpackPrefetch: true */
            /* webpackPreload: true */
            "./autorun"
        );
        console.debug("[Boot] Autorunning code loaded");
    },

    // Components
    async () => {
        await Promise.all([
            import("@/components/CustomElements"),
            import("@/components/backports")
        ]);
        console.debug("[Boot] Backport components loaded.");
    }
]).catch(window.reportError);
